import * as React from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';

import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';

import { changeViewModeAction } from '../../redux/actions';

import { __t, applyTranslations } from 'utils/language';

import './select-story-snippets-entities-count.scss';

applyTranslations(require('./select-story-snippets-entities-count.i18n.json'));

import { State } from 'types';
import { ViewMode } from '../../types';

interface StateProps {
  count: number,
  selectedCount: number,
  viewMode: ViewMode
}

interface DispatchProps {
  onChangeViewMode: (m: ViewMode) => void
}

type Props = StateProps & DispatchProps;

const SelectStorySnippetsEntitiesCount = ({
  count,
  selectedCount,
  viewMode,
  onChangeViewMode
}: Props): JSX.Element => (
  <div
    className={classnames('select-story-snippets-entities-count', {
      'select-story-snippets-entities-count--bold': selectedCount > 0
    })}
  >
    {selectedCount > 0 ? (
      __t('select_story_snippets_entities_count.selected_snippets', {
        count: selectedCount,
        withPlural: selectedCount
      })
    ) : (
      __t('select_story_snippets_entities_count.snippets', {
        count,
        withPlural: count
      })
    )}
    <div className="select-story-snippets-entities-count__view-switch">
      <span
        className={classnames('select-story-snippets-entities-count__view-switch-button', {
          'select-story-snippets-entities-count__view-switch-button--left': true,
          'select-story-snippets-entities-count__view-switch-button--active':
            viewMode === 'grid'
        })}
        onClick={() => onChangeViewMode('grid')}
      >
        <SVGDynamicIcon
          name="grid-view-custom-fg"
          customColor={
            viewMode === 'grid'
              ? 'primary'
              : 'grey-light'
          }
          width={18}
          height={18}
        />
      </span>
      <span
        className={classnames('select-story-snippets-entities-count__view-switch-button', {
          'select-story-snippets-entities-count__view-switch-button--right': true,
          'select-story-snippets-entities-count__view-switch-button--active':
            viewMode === 'preview-grid',
          'select-story-snippets-entities-count__view-switch-button--disabled':
            count === 0
        })}
        onClick={
          count === 0
            ? undefined
            : () => onChangeViewMode('preview-grid')
        }
      >
        <SVGDynamicIcon
          name="grid-view-preview-custom-fg"
          customColor={
            viewMode === 'preview-grid'
              ? 'primary'
              : 'grey-light'
          }
          width={23}
          height={18}
        />
      </span>
    </div>
  </div>
);

const mapStateToProps = ({ selectStorySnippets }: State): StateProps => ({
  count: selectStorySnippets.storySnippets?.length ?? 0,
  selectedCount: selectStorySnippets.selectedStorySnippets.length,
  viewMode: selectStorySnippets.viewMode
});

const mapDispatchToProps = (dispatch): DispatchProps => ({
  onChangeViewMode: mode => dispatch(changeViewModeAction(mode))
});

export default connect(mapStateToProps, mapDispatchToProps)(SelectStorySnippetsEntitiesCount);
